import { Column, Id } from "@dgs/core";
import { endOfYear, format, startOfYear } from "date-fns";
import styled from "styled-components";
import { AnalyticsEventFilterRequest, EventAnalyticsFilterValues } from "./analyticsTypes";

export const initialEventAnalyticsFilter: EventAnalyticsFilterValues = {
	start: format(startOfYear(new Date()), "yyyy-MM-dd"),
	end: format(endOfYear(new Date()), "yyyy-MM-dd"),
	attributes: [{ type: null, value: null }],
};

export const mapAnalyticsFilterValuesToRequest = (values: EventAnalyticsFilterValues): AnalyticsEventFilterRequest => ({
	...values,
	attributes: values.attributes
		.filter((a) => !!a.type && !!a.value)
		.map((a) => ({
			type: a.type,
			value:
				a.type === "EVENT.FORMAT"
					? (a.value?.map((v) => v.name) ?? null)
					: (a.value?.map((v) => (v as any).id as Id) ?? null),
		})),
});

export const ChartColumn = styled(Column)`
	padding: ${({ theme }) => theme.spacing(4)};
	background-color: ${({ theme }) => theme.colors.card["background"].background};
`;
